import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';
import { ProIntent, ProSize } from '../../utils/enums';
import { ProIconButton } from '../Button/ProIconButton';
import { ProIconDataButtons } from '../Icons/IconData';

export const ProFilterPopup = ({
    children,
    isOpen,
    setIsOpen,
    isActive,
}: PropsWithChildren<{
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    isActive: boolean;
}>) => (
    <div className="ProFilterPopup">
        <ProIconButton
            icon={ProIconDataButtons.search}
            mainIntent={ProIntent.Secondary}
            tooltip="Search"
            size={ProSize.Small}
            className="SearchButton"
            onClick={() => {}}
            placement="bottom"
        />
        <ProIconButton
            icon={ProIconDataButtons.filter}
            onClick={() => setIsOpen((cur) => !cur)}
            mainIntent={isActive ? ProIntent.Edit : ProIntent.Secondary}
            tooltip="Filter"
            size={ProSize.Small}
            className={classNames('FilterButton', isOpen && 'FilterButton--open', isActive && 'FilterButton--active')}
            placement="bottom"
        />

        <div className={classNames('ProFilterPopup__content', isOpen && 'ProFilterPopup__content--open')}>
            <div className="ProFilterPopup__contentHeader">
                <ProIconButton
                    icon={ProIconDataButtons.filter}
                    onClick={() => setIsOpen((cur) => !cur)}
                    mainIntent={isActive ? ProIntent.Edit : ProIntent.Secondary}
                    tooltip="Filter"
                    size={ProSize.Small}
                    className={classNames(
                        'FilterButton',
                        isOpen && 'FilterButton--open',
                        isActive && 'FilterButton--active'
                    )}
                    placement="bottom"
                />
                <h2>Filter</h2>
            </div>
            <div className="ProFilterPopup__contentButtons">{children}</div>
        </div>
    </div>
);
